import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { TbWorld, TbLayerGroup, TbTrophy, TbShieldCheck } from "react-icons/tb";
import { FaLayerGroup } from "react-icons/fa";
import { motion } from "framer-motion";

const Features = () => {
  const boxItems = [
    {
      title: "Extensive Global Reach",
      description:
        "Our global music distribution services cover all major streaming platforms, including Spotify, Apple Music, Amazon Music and more.",
      cardClass: "card-purple",
      icon: <TbWorld />
    },
    {
      title: "Easy and Transparent Distribution Process",
      description:
        "Selling your music globally shouldn’t be complicated. At FTtunes, we offer user-friendly platform that allows you to distribute your music effortlessly.",
      cardClass: "card-orange",
      icon: <FaLayerGroup  />
    },
    {
      title: "Top Music Sales Solutions",
      description:
        "Our dedication to top music sales solutions includes FTtunes distribution and advanced marketing tools to effectively promote your music.",
      cardClass: "card-pink",
      icon: <TbTrophy />
    },
    {
      title: "Keep Control of Your Music",
      description:
        "At FTtunes, we believe that artists should have full control over their music. That’s why we offer flexible distribution options that allow you to retain your rights and royalties.",
      cardClass: "card-orange",
      icon: <TbShieldCheck />
    },
  ];

  return (
    <section className="sell-music-features">
      <Container>
        <Row className="align-items-center">
          <Col lg={4} className="mb-5 mb-lg-0">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <div className="mini-title">COMPREHENSIVE ADVANTAGES</div>
              <h3 style={{ fontSize: "42px", fontWeight: "700", color: "#fff", marginBottom: "30px", lineHeight: "1.2" }}>
                Elevate Your <br /> Music Career <br /> <span className="text-gradient">Without Limits</span>
              </h3>
              <p style={{ fontSize: "14px", color: "#94a3b8", lineHeight: "1.6" }}>
                Discover unparalleled opportunities with our seamless music distribution services, designed to amplify your reach and maximize your potential.
              </p>
            </motion.div>
          </Col>
          <Col lg={8}>
            <Row className="g-4">
              {boxItems.map((item, index) => (
                <Col md={6} key={index}>
                  <motion.div 
                    className={`feature-grid-card ${item.cardClass}`}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: index * 0.15 }}
                  >
                    <h4>{item.title}</h4>
                    <p className="sell_your_music_para-inner">{item.description}</p>
                    <div className="feature-grid-icon" style={{ color: item.cardClass === "card-purple" ? "#b042ff" : item.cardClass === "card-pink" ? "#ec4899" : "#f97316" }}>
                      {item.icon}
                    </div>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
